import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

import { TaxAdministration } from './pages/taxAdministration.lazy';
import { ReportOperation } from './ReportOperation';
import { ReportsAdministration } from './Reports';
import { TaxOperation } from './TaxOperation';

export const AdministrationRouting = () => {
  return (
    <Routes>
      <Route
        path="manage/taxes/*"
        element={
          <RouteAuth access={[Role.FormsAdmin]}>
            <TaxAdministration />
          </RouteAuth>
        }
      />
      <Route
        path="manage/operations/*"
        element={
          <RouteAuth access={[Role.FormsAdmin]}>
            <TaxOperation />
          </RouteAuth>
        }
      />
      <Route
        path="manage/reports/*"
        element={
          <RouteAuth access={[Role.FormsAdmin]}>
            <ReportOperation />
          </RouteAuth>
        }
      />
      <Route
        path="manage/complementary/*"
        element={
          <RouteAuth access={[Role.FormsAdmin]}>
            <ReportsAdministration />
          </RouteAuth>
        }
      />
    </Routes>
  );
};
